export default __webpack_public_path__ + "images/5Q.bd23b1b.png";